import {
  CoreFeeType,
  FeeCalculationBasis,
  FeeChargingFrequency,
} from 'further-types/investment';

export const CoreFeeTypeLabels = {
  [CoreFeeType.InitialPercentage]: 'Initial %',
  [CoreFeeType.RecurringPercentage]: 'Recurring %',
  [CoreFeeType.InitialFixed]: 'Initial £',
  [CoreFeeType.RecurringFixed]: 'Recurring £',
};

export const FeeChargingFrequencyLabels = {
  [FeeChargingFrequency.Monthly]: 'Monthly',
  [FeeChargingFrequency.Quarterly]: 'Quarterly',
  [FeeChargingFrequency.Yearly]: 'Yearly',
};

export const FeeCalculationBasisLabels = {
  [FeeCalculationBasis.PercentageOfTotalCommitment]: 'Total commitment',
  [FeeCalculationBasis.PercentageOfUnrealisedAssetCost]:
    'Unrealised asset cost',
  [FeeCalculationBasis.Fixed]: 'Fixed',
};
